<template>
  <v-container fluid>
    <h3 class="page-title">預約記錄 Log</h3>
    <v-row>
      <v-col cols="3">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateRangeText"
              label="選擇日期區間"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" range></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="auto">
        <v-btn color="primary" @click="download">下載</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import downloadCsv from "download-csv";

export default {
  name: "ReservationLog",
  data: () => ({
    date: [],
    dateMenu: false,
  }),
  created() {},
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  watch: {
    date(val) {
      if (val.length === 2) {
        this.dateMenu = false;
      }
    },
  },
  methods: {
    async download() {
      if (!this.date.length) {
        return false;
      }

      let result = (
        await this.axios.post(`/dashboard/reservationLog`, {
          startDate: this.date[0],
          endDate: this.date[1],
        })
      ).data;

      downloadCsv(
        result,
        {},
        `${this.date[0]} ~ ${this.date[1]} 預約 Log 記錄`
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
